// extracted by mini-css-extract-plugin
export default {"spinnerBorder":"styles_spinnerBorder__UhhsL","spinner-border":"styles_spinner-border__r9wiz","srOnly":"styles_srOnly__T2UGi"};